/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 提交订单
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  submitMovieOrderReq: order.SubmitMovieOrderReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.SubmitMovieOrderRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/movie/order`,
    data: submitMovieOrderReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
